<script>
import { formButton } from 'tb-design_system-web'
import { useForm } from 'vee-validate'
import { onMounted, ref, provide } from 'vue'
import { useMeta } from 'vue-meta'
import { useRouter } from 'vue-router'
import * as yup from 'yup'

import formBankAccount from '@/components/shared/formBankAccount.vue'
import RegisterLayout from '@/components/shared/registerLayout.vue'
import StepProgressBar from '@/components/shared/stepProgressBar.vue'
import { validateStepAccess } from '@/composables/utils/onboardingGuards'
import { handleGlobalError } from '@/services/errorHandler'
import { useOnboardingStore } from '@/stores/onboarding'

export default {
  name: 'RegisterFinishPJStep2',
  components: {
    RegisterLayout,
    StepProgressBar,
    formBankAccount,
    formButton
  },
  setup() {
    useMeta({ title: 'Cadastro PJ - Etapa 2/3' })

    const router = useRouter()
    const onboardingStore = useOnboardingStore()

    const step2Data = onboardingStore.getStepData(2) || {}

    const loading = ref(false)
    const banksValue = ref(
      step2Data?.banks?.length ? [...step2Data.banks] : [{ bankId: '', agency: '', account: '' }]
    )

    onMounted(async () => {
      validateStepAccess(onboardingStore, 'PJ', [1], router)
    })

    const onSubmitAction = () => {
      alreadySubmittedOnce.value = true
      return onSubmit()
    }

    const alreadySubmittedOnce = ref(false)
    provide('alreadySubmittedOnce', alreadySubmittedOnce)

    const { handleSubmit } = useForm({
      validationSchema: yup.object({
        banks: yup.array().of(
          yup.object().shape({
            id: yup.object().required(),
            agency: yup.string().required(),
            account: yup.string().required()
          })
        )
      })
    })

    const onSubmit = handleSubmit(async () => {
      loading.value = true
      try {
        onboardingStore.setStepData(2, {
          banks: banksValue.value
        })
        router.push('/finalizar-cadastro/documentos-pj')
      } catch (err) {
        handleGlobalError(err)
      } finally {
        loading.value = false
      }
    })

    return {
      loading,
      onSubmitAction,

      banksValue,
      alreadySubmittedOnce
    }
  }
}
</script>

<template>
  <RegisterLayout>
    <div class="col-12 col-md-9 h-100 onboarding pb-5">
      <div class="row">
        <StepProgressBar class="mt-5 mb-5" :steps="['Sócios', 'Contas', 'Anexos']" :current="2" />
      </div>
      <div class="row d-flex justify-content-center mt-4">
        <div class="col-12 col-md-6 col-lg-5 d-flex flex-column align-items-center">
          <p class="text-center">Cadastrar conta bancária da empresa</p>

          <form-bank-account v-model="banksValue" :allowMultiple="true" />

          <form-button
            class="col-12 form-input"
            title="Próximo"
            :loading="loading"
            :isDisabled="loading"
            @clicked="onSubmitAction"
          />
        </div>
      </div>
    </div>
  </RegisterLayout>
</template>

<style lang="scss" scoped></style>
